import { ShieldCheck, ShieldAlert, Clock } from "lucide-react";

const META = {
  verified: { l: "Receipt verified", c: "#22c55e", I: ShieldCheck },
  approved: { l: "Receipt approved", c: "#22c55e", I: ShieldCheck },
  flagged: { l: "Receipt flagged", c: "#ef4444", I: ShieldAlert },
  manual_review: { l: "Needs manual review", c: "#eab308", I: Clock },
};

export default function ProofBadge({ reg }) {
  const m = META[reg.proof_status];
  if (!m) return null;
  const reasons = (reg.proof_check?.reasons || []).join(" • ");
  const amt = reg.proof_check?.amount_detected;
  const title = [reasons, amt != null ? `Detected amount: ${amt}` : "", reg.proof_review_note ? `Player note: ${reg.proof_review_note}` : ""].filter(Boolean).join("\n");
  return (
    <span title={title || m.l} data-testid={`proof-status-${reg.registration_id}`}
      className="text-[10px] mono glass rounded-full px-2 py-1 flex items-center gap-1" style={{ color: m.c }}>
      <m.I className="w-3 h-3" /> {m.l}
    </span>
  );
}
